// NoDefinedLayout – placeholder "Pracujeme na tom": zobrazí se pro všechny zatím nenaimplementované sekce
import { useNavigate } from 'react-router-dom'
import { Button } from '@heroui/react'

export function NoDefinedLayout() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-6 p-8 text-center">
      <div className="text-6xl">🚧</div>
      <h1 className="text-2xl font-bold text-gray-700">Pracujeme na tom</h1>
      <p className="text-gray-400 max-w-sm">
        Tato sekce ještě není definována. Brzy zde budou k dispozici data, grafy a sestavy.
      </p>
      <Button variant="secondary" onPress={() => navigate('/')}>
        <span className="text-xl leading-none">🏠</span> Zpět na hlavní stránku
      </Button>
    </div>
  )
}
